import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { auth, firestore as db } from "../../FirebaseConfig";
import { doc, onSnapshot } from "firebase/firestore";
import Logo from "../assests/logo.png";
import AnnouncementCarousel from "../Announcement";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  

  const handleLogout = () => {
    signOut(auth).then(() => {
      setUser(null);
      setIsAccountDropdownOpen(false);
    });
  };
  const handleSearch = () => {
    if (searchQuery.trim()) {
      window.location.href = `/shop?search=${encodeURIComponent(searchQuery.trim())}`;
    }
  };
  

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        fetchCartItemCount(currentUser.uid);
      }
    });

    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchCartItemCount = (userId) => {
    const cartRef = doc(db, "customers", userId);
    return onSnapshot(cartRef, (cartSnap) => {
      if (cartSnap.exists() && cartSnap.data().items) {
        const totalItems = cartSnap.data().items.reduce((sum, item) => sum + item.quantity, 0);
        setCartCount(totalItems);
      } else {
        setCartCount(0);
      }
    });
  };

  return (
    <>
      <AnnouncementCarousel />

      {/* Navigation Bar */}
      <nav className="bg-white shadow-md fixed top-7 left-0 w-full z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-20">




            {/* Mobile Menu Toggle (Only visible on Mobile) */}
            {isMobile && (
              <div className="flex ">

                <button
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  className="p-2 text-gray-600 hover:text-orange-500 transition-colors"
                >
                  {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
                <a style={{ left: "calc(45% - 90px)", top: 10 }}
                  href={user ? "/cart" : "/login"} className="absolute  hover:text-orange-500 transition-colors">
                  <img
                    src={cartCount > 0 ? "/assets/General/cart_open.png" : "/assets/General/cart_close.png"}
                    className="h-16 w-16"
                    alt="Cart"
                  />
                  {cartCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                      {cartCount}
                    </span>
                  )}
                </a>



              </div>

            )}

            {!isMobile && <a href={user ? "/cart" : "/login"} className="relative hover:text-orange-500 transition-colors">
              <img
                src={cartCount > 0 ? "/assets/General/cart_open.png" : "/assets/General/cart_close.png"}
                className="h-16 w-16"
                alt="Cart"
              />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </a>


            }
            {/* Left Section - Account Icon */}


            {/* Center Section - Product Links + Logo */}
            {!isMobile && (
              <div className="flex left-0 items-center space-x-2">
                <a href="/shop" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Products</a>
                <a href="/shop?category=beekeeping" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Bee Hives</a>
                <a href="/learn-beekeeping" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Beekeeping</a>
                <div className="w-30"> </div>
              </div>
            )}

            {/* Logo - Exactly Centered */}
            <div className="absolute left-1/2 transform -translate-x-1/2">
              <a href="/">
                <img src={Logo} className="h-18 w-auto" alt="Logo" />
              </a>
            </div>

            {/* Right Section - Recipes, Blog, Mission & Cart */}
            {!isMobile && (
              <div className="flex items-center space-x-6">
                <a href="/recipes" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Recipes</a>
                <a href="/blog" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Blog</a>
                <a href="/about" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Mission</a>
                <div className="w-30"> </div>

                {/* Cart Icon */}

              </div>
            )}



<div className="relative">
  {/* <button
    onClick={() => setShowSearch(!showSearch)}
    className="text-gray-600 text-3xl hover:text-orange-500"
  >
    🔍
  </button> */}
  <button
               onClick={() => setShowSearch(!showSearch)}
                className="flex items-center  "
              >
                <img src="/assets/General/Search.png" className="h-8 w-8" alt="Search" />
              </button>

  {showSearch && (
    <div className="absolute right-0 mt-2 bg-white shadow-lg rounded-md flex items-center space-x-2 p-2 z-50">
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search products..."
        className="border px-3 py-1 rounded-md focus:outline-none"
      />
      <button
        onClick={handleSearch}
        className="bg-orange-500 text-white px-3 py-1 rounded-md hover:bg-orange-600"
      >
        Go
      </button>
    </div>
  )}
</div>



<div className="absolute items-center space-x-2 right-[calc(45%-90px)] bottom-[22px] md:right-[calc(15%-50px)]">
              <button
                onClick={() => {
                  if (user) {
                    setIsAccountDropdownOpen(!isAccountDropdownOpen);
                  } else {
                    window.location.href = "/login"; // Redirects to login page
                  }
                }}
                className="flex items-center  "
              >
                <img src="/assets/General/account_icon.png" className="h-10 w-10" alt="Account" />
              </button>
              {isAccountDropdownOpen && (
                <div className="absolute right-10  w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                  <div className="py-1">
                    <a href="/account" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      My Account
                    </a>
                    <a href="/orders" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      My Orders
                    </a>
                    <button
                      onClick={handleLogout}
                      className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                    >
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>




          </div>
        </div>
      </nav>

      {/* Mobile Side Navigation */}
      {isMobileMenuOpen && (
        <div className="fixed inset-y-0 mt-8 left-0 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50">
          <div className="flex flex-col h-full">
            {/* Close Button */}
            <div className="flex justify-between items-center p-4 border-b">
              <a href="/">
                <img src={Logo} className="h-10" alt="Logo" />
              </a>
              <button onClick={() => setIsMobileMenuOpen(false)}>
                <X className="h-6 w-6 text-gray-600 hover:text-orange-500" />
              </button>
            </div>

            {/* Mobile Menu Items */}
            <div className="p-2">
              <a href="/shop" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Products</a>
              <a href="/shop?category=beekeeping" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Bee Hives</a>
              <a href="/learn-beekeeping" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Beekeeping</a>
              <a href="/recipes" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Recipes</a>
              <a href="/blog" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Blog</a>
              <a href="/about" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Mission</a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;



// import React, { useState, useEffect } from "react";
// import { Menu, X, Search, ShoppingBag, User, ChevronRight } from "lucide-react";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { auth, firestore as db } from "../../FirebaseConfig";
// import { doc, onSnapshot } from "firebase/firestore";
// import Logo from "../assests/logo.png";
// import AnnouncementCarousel from "../Announcement";

// const Header = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [user, setUser] = useState(null);
//   const [cartCount, setCartCount] = useState(0);
//   const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
//   const [showSearch, setShowSearch] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isScrolled, setIsScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setIsScrolled(window.scrollY > 20);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
//       setUser(currentUser);
//       if (currentUser) fetchCartItemCount(currentUser.uid);
//     });
//     return () => unsubscribe();
//   }, []);

//   const fetchCartItemCount = (userId) => {
//     const cartRef = doc(db, "customers", userId);
//     return onSnapshot(cartRef, (cartSnap) => {
//       if (cartSnap.exists() && cartSnap.data().items) {
//         const total = cartSnap.data().items.reduce((sum, item) => sum + item.quantity, 0);
//         setCartCount(total);
//       }
//     });
//   };

//   const navLinks = [
//     { name: "Products", path: "/shop" },
//     { name: "Bee Hives", path: "/shop?category=beekeeping" },
//     { name: "Beekeeping", path: "/learn-beekeeping" },
//     { name: "Recipes", path: "/recipes" },
//     { name: "Blog", path: "/blog" },
//     { name: "Mission", path: "/about" },
//   ];

//   return (
//     <>
//       <AnnouncementCarousel />

//       {/* --- DESKTOP HEADER --- */}
//       <nav className={`fixed w-full z-50 transition-all duration-300 top-8 ${isScrolled ? "bg-white/80 backdrop-blur-md shadow-sm h-16" : "bg-white h-20"}`}>
//         <div className="max-w-7xl mx-auto h-full px-6 flex items-center justify-between">
          
//           {/* Left: Menu Links */}
//           <div className="hidden lg:flex items-center space-x-8 flex-1">
//             {navLinks.slice(0, 3).map((link) => (
//               <a key={link.name} href={link.path} className="text-sm font-bold text-gray-700 hover:text-orange-500 transition-colors uppercase tracking-wider">
//                 {link.name}
//               </a>
//             ))}
//           </div>

//           {/* Center: Logo */}
//           <div className="flex-shrink-0">
//             <a href="/">
//               <img src={Logo} className={`transition-all duration-300 ${isScrolled ? "h-10" : "h-14"}`} alt="Logo" />
//             </a>
//           </div>

//           {/* Right: Icons & Extra Links */}
//           <div className="flex items-center justify-end space-x-6 flex-1">
//             <div className="hidden lg:flex items-center space-x-6 mr-4">
//               {navLinks.slice(3).map((link) => (
//                 <a key={link.name} href={link.path} className="text-sm font-bold text-gray-700 hover:text-orange-500 transition-colors uppercase tracking-wider">
//                   {link.name}
//                 </a>
//               ))}
//             </div>

//             <button onClick={() => setShowSearch(true)} className="p-1">
//               <img src="/assets/General/Search.png" className="h-7 w-7" alt="Search" />
//             </button>

//             <div className="relative">
//               <button onClick={() => user ? setIsAccountDropdownOpen(!isAccountDropdownOpen) : window.location.href="/login"}>
//                 <img src="/assets/General/account_icon.png" className="h-7 w-7" alt="Account" />
//               </button>
//             </div>

//             <a href={user ? "/cart" : "/login"} className="relative">
//               <img src={cartCount > 0 ? "/assets/General/cart_open.png" : "/assets/General/cart_close.png"} className="h-10 w-10" alt="Cart" />
//               {cartCount > 0 && (
//                 <span className="absolute -top-1 -right-1 bg-orange-500 text-white text-[10px] font-bold h-5 w-5 rounded-full flex items-center justify-center border-2 border-white">
//                   {cartCount}
//                 </span>
//               )}
//             </a>
//           </div>
//         </div>
//       </nav>

//       {/* --- MOBILE INNOVATIVE APP-BAR (Bottom) --- */}
//       <div className="lg:hidden fixed bottom-0 left-0 right-0 z-[60] bg-white border-t border-gray-100 pb-safe">
//         <div className="flex items-center justify-around h-16">
//           <button onClick={() => setIsMobileMenuOpen(true)} className="flex flex-col items-center justify-center space-y-1">
//             <Menu className="h-6 w-6 text-gray-700" />
//             <span className="text-[10px] font-bold uppercase text-gray-500">Menu</span>
//           </button>
          
//           <button onClick={() => setShowSearch(true)} className="flex flex-col items-center justify-center space-y-1">
//             <img src="/assets/General/Search.png" className="h-6 w-6" alt="Search" />
//             <span className="text-[10px] font-bold uppercase text-gray-500">Search</span>
//           </button>

//           <a href="/" className="flex flex-col items-center justify-center -mt-8 bg-white p-3 rounded-full shadow-lg border border-gray-50">
//             <img src={Logo} className="h-8 w-8" alt="Home" />
//           </a>

//           <button 
//             onClick={() => user ? window.location.href="/account" : window.location.href="/login"}
//             className="flex flex-col items-center justify-center space-y-1"
//           >
//             <img src="/assets/General/account_icon.png" className="h-6 w-6" alt="Account" />
//             <span className="text-[10px] font-bold uppercase text-gray-500">Profile</span>
//           </button>

//           <a href={user ? "/cart" : "/login"} className="flex flex-col items-center justify-center space-y-1 relative">
//             <img src={cartCount > 0 ? "/assets/General/cart_open.png" : "/assets/General/cart_close.png"} className="h-7 w-7" alt="Cart" />
//             {cartCount > 0 && (
//                <span className="absolute -top-1 right-0 bg-orange-600 text-white text-[9px] font-bold h-4 w-4 rounded-full flex items-center justify-center">
//                  {cartCount}
//                </span>
//             )}
//             <span className="text-[10px] font-bold uppercase text-gray-500">Cart</span>
//           </a>
//         </div>
//       </div>

//       {/* --- MOBILE MENU DRAWER (All Options Included) --- */}
//       <div className={`fixed inset-0 z-[100] transition-transform duration-500 ease-in-out ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"}`}>
//         <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" onClick={() => setIsMobileMenuOpen(false)} />
//         <div className="absolute inset-y-0 left-0 w-[85%] bg-white shadow-2xl flex flex-col">
//           <div className="p-6 border-b flex justify-between items-center">
//             <img src={Logo} className="h-10" alt="Logo" />
//             <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 bg-gray-50 rounded-full">
//               <X className="h-6 w-6 text-gray-500" />
//             </button>
//           </div>
          
//           <div className="flex-1 overflow-y-auto py-4">
//             <div className="px-6 mb-4">
//               <p className="text-[10px] font-black uppercase text-orange-500 tracking-[0.2em]">Our Harvest</p>
//             </div>
//             {navLinks.map((link) => (
//               <a 
//                 key={link.name} 
//                 href={link.path}
//                 className="flex items-center justify-between px-6 py-4 text-xl font-bold text-gray-800 border-b border-gray-50 active:bg-orange-50"
//               >
//                 {link.name}
//                 <ChevronRight className="h-5 w-5 text-gray-300" />
//               </a>
//             ))}
//           </div>

//           <div className="p-6 bg-gray-50">
//             {user ? (
//               <button onClick={() => signOut(auth)} className="w-full py-4 bg-white border border-red-100 text-red-500 font-bold rounded-xl shadow-sm">
//                 Log Out
//               </button>
//             ) : (
//               <a href="/login" className="block w-full py-4 bg-orange-500 text-white text-center font-bold rounded-xl shadow-lg">
//                 Sign In
//               </a>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* --- SEARCH OVERLAY --- */}
//       {showSearch && (
//         <div className="fixed inset-0 z-[110] bg-white/95 backdrop-blur-xl animate-in fade-in duration-300 flex flex-col p-6">
//           <div className="flex justify-end">
//             <button onClick={() => setShowSearch(false)} className="p-4"><X className="h-8 w-8 text-gray-400" /></button>
//           </div>
//           <div className="flex-1 flex flex-col items-center justify-center max-w-4xl mx-auto w-full">
//              <p className="text-orange-500 font-black tracking-widest uppercase mb-6 text-sm">Purest Honey Search</p>
//              <div className="w-full flex items-center border-b-2 border-gray-900 pb-4">
//                <input 
//                  autoFocus
//                  className="w-full text-3xl md:text-5xl font-light outline-none bg-transparent"
//                  placeholder="Search products..."
//                  value={searchQuery}
//                  onChange={(e) => setSearchQuery(e.target.value)}
//                  onKeyDown={(e) => e.key === 'Enter' && (window.location.href=`/shop?search=${searchQuery}`)}
//                />
//                <button onClick={() => window.location.href=`/shop?search=${searchQuery}`} className="bg-orange-500 p-4 rounded-full text-white ml-4 shadow-xl">
//                  <Search className="h-6 w-6" />
//                </button>
//              </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Header;